import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-support',
  template: `
    <div class="card" *ngIf="showSupport; else notAllowed">
      <h5 class="card-header">Support</h5>
      <div class="card-body">
        <div class="support-container">
          <iframe
            src="https://docsbot.ai/iframe/ZdcUBjHkHF017MGzd9mB/3Rz1xIulDBf9LbCNx2MX"
            width="100%"
            height="650"
            frameborder="0"
            allowtransparency="true"
            scrolling="no"
          >
          </iframe>
        </div>
      </div>
    </div>
    <ng-template #notAllowed> </ng-template>
  `,
  styles: [
    `
      .support-container {
        width: 100%;
      }
    `,
  ],
})
export class SupportComponent implements OnInit {
  showSupport: boolean = false;

  constructor(private router: Router) {}

  ngOnInit() {
    const policyName = localStorage.getItem('policyName');
    const userType = localStorage.getItem('ut')?.toLowerCase();
    this.showSupport =
      policyName === 'Operator' ||
      policyName === 'Senior Operator Role' ||
      policyName === 'Admin' ||
      userType === 'useradmin' ||
      userType === 'admin';

    if (!this.showSupport) {
      this.router.navigate(['/auth/login']);
    }
  }
}
